<template>
  <div>
    <el-table v-if="detailMode === 'detail'" :data="bills">
      <el-table-column label="时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createdTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="businessType" label="类型">
        <template slot-scope="scope">{{
          getTypeLabel(scope.row.businessType)
        }}</template>
      </el-table-column>
      <el-table-column prop="fromUid" label="转出用户ID">
        <template slot-scope="scope">{{ scope.row.fromUid }}</template>
      </el-table-column>
      <el-table-column prop="fromType" label="转出账户类型">
        <template slot-scope="scope">
          {{ typeText(scope.row.fromType) }}</template
        >
      </el-table-column>
      <el-table-column prop="toUid" label="转入用户ID">
        <template slot-scope="scope">{{ scope.row.toUid }}</template>
      </el-table-column>
      <el-table-column prop="fromType" label="转入账户类型">
        <template slot-scope="scope">{{
          typeText(scope.row.toType) || ''
        }}</template>
      </el-table-column>
      <el-table-column label="数量">
        <template slot-scope="scope">
          <span>{{ scope.row.amount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="fromBalance" label="转出账户变更后余额">
        <template slot-scope="scope">
          <span>{{ scope.row.fromBalance }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="toBalance" label="转入账户变更后余额">
        <template slot-scope="scope">
          <span>{{ scope.row.toBalance }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="coinType" label="币种"></el-table-column>
    </el-table>
    <el-table v-else-if="detailMode === 'focus'" :data="bills">
      <el-table-column label="时间">
        <template slot-scope="scope">{{
          scope.row.createdTime | moment
        }}</template>
      </el-table-column>
      <el-table-column label="类型">
        <template slot-scope="scope">{{
          getTypeLabel(scope.row.businessType)
        }}</template>
      </el-table-column>
      <el-table-column prop="fromType" label="变更">
        <template slot-scope="scope">{{ getChangeType(scope.row) }}</template>
      </el-table-column>
      <el-table-column prop="amount" label="数量">
        <template slot-scope="scope"
          >{{ scope.row.amount }} {{ scope.row.coinType }}</template
        >
      </el-table-column>
      <el-table-column label="变更后可用余额">
        <template slot-scope="scope">
          {{ getBalance(scope.row) }}
          {{ getBalance(scope.row) ? scope.row.coinType : '--' }}
        </template>
      </el-table-column>
      <el-table-column label="变更后冻结数量">
        <template slot-scope="scope">
          {{ getFrozenBalance(scope.row) }}
          {{ getFrozenBalance(scope.row) ? scope.row.coinType : '--' }}
        </template>
      </el-table-column>
    </el-table>
    <el-table v-if="detailMode === 'desc'" :data="bills">
      <el-table-column width="160" label="时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createdTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column width="130" prop="businessType" label="类型">
        <template slot-scope="scope">{{
          getTypeLabel(scope.row.businessType)
        }}</template>
      </el-table-column>
      <el-table-column label="内容">
        <template slot-scope="scope">
          用户
          <b>{{ scope.row.fromUid }}</b>
          {{ typeText(scope.row.fromType) || '' }} --> 用户
          <b>{{ scope.row.toUid }}</b>
          {{ typeText(scope.row.toType) || '' }}，
          <b>{{ scope.row.amount }}</b>
          {{ scope.row.coinType }}
        </template>
      </el-table-column>
      <el-table-column label="变化后">
        <template slot-scope="scope">
          用户{{ scope.row.fromUid }} {{ typeText(scope.row.fromType) || '' }}:
          <b>{{ scope.row.fromBalance }}</b>
          {{ scope.row.coinType }}, 用户{{ scope.row.toUid }}
          {{ typeText(scope.row.toType) || '' }}:
          <b>{{ scope.row.toBalance }}</b>
          {{ scope.row.coinType }}
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    ></pagination>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'BillList',
  props: ['detailMode', 'uid'],
  data() {
    return {
      typeKeys: {
        '1': '余额转出',
        '2': '余额转入',
        '3': '冻结增加',
        '4': '冻结扣除',
        '1_3': '冻结',
        '2_4': '解冻',
        '1_2': '划转'
      },
      getTypeLabel: type => {
        return (
          (this.billTypes.find(item => item.value === type) || {}).label || type
        );
      }
    };
  },
  computed: {
    ...mapState('userBill', [
      'pagination',
      'billTypes',
      'bills',
      'totalCount',
      'accountTypes'
    ]),
    ...mapGetters('userBill', ['billList'])
  },
  components: {
    Pagination
  },
  methods: {
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    getRelativeType(userId, entity, fromOrTo) {
      if (fromOrTo === 'from') {
        if (entity.fromUid === userId) return entity.fromType;
      } else if (fromOrTo === 'to') {
        if (entity.toUid === userId) return entity.toType;
      }
      return null;
    },
    getRelativeAmount(entity, fromOrTo) {
      return fromOrTo === 'from' ? -1 * entity.amount : entity.amount;
    },
    typeText(type) {
      return this.getAccountType(type) + (type < 0 ? '冻结' : '余额');
    },
    getBalance(entity) {
      if (entity.fromUid === this.uid && entity.fromType > 0) {
        return entity.fromBalance;
      } else if (entity.toUid === this.uid && entity.toType > 0) {
        return entity.toBalance;
      }
      return '';
    },
    getFrozenBalance(entity) {
      if (entity.fromUid === this.uid && entity.fromType <= 0) {
        return entity.fromBalance;
      } else if (entity.toUid === this.uid && entity.toType <= 0) {
        return entity.toBalance;
      }
      return '';
    },
    getAccountType(type) {
      const accoutType = this.accountTypes[type];
      return accoutType ? accoutType + '杠杆 ' : '';
    },
    getChangeType(entity) {
      const userId = this.uid;
      const types = [];
      const walletTypes = ['from', 'to'];
      let _type;
      walletTypes.forEach(type => {
        const walletType = this.getRelativeType(userId, entity, type);
        if (walletType) {
          _type = walletType;
          //如果fromUid == user 会对from进行一次处理， 如果toUid == user会对to做一次处理
          const relativeAmount = this.getRelativeAmount(entity, type);
          if (walletType > 0) {
            if (relativeAmount < 0) {
              types.push(1);
            } else {
              types.push(2);
            }
          } else if (walletType < 0) {
            if (relativeAmount > 0) {
              types.push(3);
            } else {
              types.push(4);
            }
          }
        }
      });
      const key =
        types &&
        types
          .concat()
          .sort()
          .join('_');
      return this.getAccountType(_type) + this.typeKeys[key] || key;
    }
  }
};
</script>

<style lang="less" scoped></style>
